import axios from "axios";


class ServicosConvenia {
    configClt = {
        headers: {
            'token': `9abd4721-a3b9-49d0-85fa-480239884680`,
            'Content-Type': 'application/json', // Defina o tipo de conteúdo apropriado, se necessário
        }
    };
    configComerciais = {
        headers: {
            'token': `beaf1ff2-e658-4256-9525-fb9c32808c80`,
            'Content-Type': 'application/json', // Defina o tipo de conteúdo apropriado, se necessário
        }
    };
    configPj = {
        headers: {
            'token': `718de520-d88c-438f-8e5a-692cd9e3f631`,
            'Content-Type': 'application/json', // Defina o tipo de conteúdo apropriado, se necessário
        }
    };
   
    listarTodosClt(){
        return axios.get(` https://public-api.convenia.com.br/api/v3/employees`, this.configClt)
    }
    listarTodosComerciais(){
        return axios.get(` https://public-api.convenia.com.br/api/v3/employees`, this.configComerciais)
    }
    listarTodosPj(){
        return axios.get(` https://public-api.convenia.com.br/api/v3/employees`, this.configPj)
    }
    
    getUserClt(id){
        return axios.get(`https://public-api.convenia.com.br/api/v3/employees/${id}`, this.configClt)
    }
    getUserComercial(id){
        return axios.get(`https://public-api.convenia.com.br/api/v3/employees/${id}`, this.configComerciais)
    }
    getUserPj(id){
        return axios.get(`https://public-api.convenia.com.br/api/v3/employees/${id}`, this.configPj)
    }



}

export default new ServicosConvenia();